import { Module } from 'vuex'

interface ProblemState {
  problemId: string
  nextProblemId: string
  prevProblemId: string
}

export const problemStateModule = (): Module<ProblemState, any> => {
  return {
    namespaced: true,
    state: {
      problemId: 'ITP1_1_A',
      nextProblemId: 'ITP1_1_B',
      prevProblemId: '-1'
    },
    mutations: {
      setProblemId(state, problemId: string) {
        state.problemId = problemId
      },
      setNextProblemId(state, nextProblemId: string) {
        state.nextProblemId = nextProblemId
      },
      setPrevProblemId(state, prevProblemId: string) {
        state.prevProblemId = prevProblemId
      }
    },
    actions: {},
    getters: {
      problemId: state => state.problemId,
      nextProblemId: state => state.nextProblemId,
      prevProblemId: state => state.prevProblemId
    }
  }
}
